import { ExtendedFieldWithValueDto } from 'theSource/types';
import { mapCategories } from 'theSource/utils';
import {
  DependentsMetadataDto,
  DependentsResponseDto,
  ExtendedMetadataDto,
} from 'theSource/features/FamilyMembers/types';
import {
  BASIC_INFORMATION_CATEGORY_NAME,
  ENROLL_IN_MEDICARE_FIELD_NAME,
  OTHER_INFORMATION_CATEGORY_NAME,
  RELATIONSHIP_FIELD_NAME,
} from './constants';

export const mapDependentsModel = (
  response: DependentsResponseDto,
  values?: { [key: string]: any }
) => {
  const metadata = response?.data?.metadata;
  const fields = mapFields(metadata);

  const mappedFields: ExtendedFieldWithValueDto[] = [];
  fields?.forEach((metadata) => {
    mappedFields?.push({
      fieldName: metadata?.fieldName,
      metadata: {
        ...metadata,
        category: getFieldCategory(metadata?.fieldName, metadata?.category),
      },
      value: values ? values[metadata?.fieldName] || null : null,
    });
  });

  const categories = mapCategories(mappedFields);
  return categories;
};

function compressRelationshipFields(
  orgRelationshipIdField: ExtendedMetadataDto,
  relationshipCodeField: ExtendedMetadataDto
) {
  return {
    ...relationshipCodeField,
    category: orgRelationshipIdField?.category,
    category_order: orgRelationshipIdField?.category_order,
    order: orgRelationshipIdField?.order,
  };
}

export function mapFields(
  metadata: DependentsMetadataDto
): ExtendedMetadataDto[] {
  const fields =
    metadata &&
    Object?.entries(metadata)?.map<ExtendedMetadataDto>(([key, value]) => ({
      fieldName: key,
      ...value,
    }));

  const orgRelationshipIdFieldIndex = fields?.findIndex(
    (field) => field?.fieldName === 'org_relationship_id'
  );
  const relationshipCodeFieldIndex = fields?.findIndex(
    (field) => field?.fieldName === 'relationship_code'
  );

  if (orgRelationshipIdFieldIndex > -1 && relationshipCodeFieldIndex > -1) {
    fields[relationshipCodeFieldIndex] = compressRelationshipFields(
      fields[orgRelationshipIdFieldIndex],
      fields[relationshipCodeFieldIndex]
    );
    fields?.splice(orgRelationshipIdFieldIndex, 1);
  }

  return fields;
}

export function getFieldCategory(key: string, category?: string) {
  if (category) {
    return category;
  }

  if (key === RELATIONSHIP_FIELD_NAME) {
    return BASIC_INFORMATION_CATEGORY_NAME;
  }

  if (key === ENROLL_IN_MEDICARE_FIELD_NAME) {
    return OTHER_INFORMATION_CATEGORY_NAME;
  }
}
